import { Reducer } from 'react'
import { SwiperPaymentEvent, SwiperPaymentState } from './types'

export const swiperPaymentStateReducer: Reducer<
  SwiperPaymentState,
  SwiperPaymentEvent
> = (_, event) => {
  switch (event.type) {
    case 'ERROR': {
      return {
        status: 'error',
        errorMessage: event.errorMessage,
        shouldPrintReceipt: event.shouldPrintReceipt,
      }
    }
    case 'PROMPT_APPROVE_SIGNATURE': {
      return {
        status: 'approvingSignature',
        transaction: event.transaction,
        signatureSrc: event.signatureSrc,
      }
    }
    case 'REVERSE_TRANSACTION': {
      return {
        status: 'reversing',
        registerID: event.registerID,
        registerSalePaymentID: event.registerSalePaymentID,
      }
    }
    case 'REVERSED': {
      return {
        status: 'reversed',
        errorMessage: event.message,
      }
    }
    case 'PROMPT_PRINT_SIGNATURE': {
      return {
        status: 'printingSignatureReceipt',
        transaction: event.transaction,
      }
    }
    case 'PROMPT_PARTIAL_APPROVAL': {
      return {
        status: 'approvingPartialPayment',
        transaction: event.transaction,
      }
    }
    case 'DONE': {
      return { status: 'done', transaction: event.transaction }
    }
    default: {
      // This `never` typing will let us know at compile time if we do not handle an existing event type. Neat !
      const _exhaustiveCheck: never = event
      return _exhaustiveCheck
    }
  }
}
